import React from "react";
import Header from "../Header";
import AppNavbar from "../Sidebar";


function AccountManagerLayout({children}) {
    return (
        <body data-sidebar="colored">
        <div id="layout-wrapper">
            <Header />
            <AppNavbar />
            <div className="main-content sect-terminalmgt">
                <div className="page-content">
                    <div className="container-fluid">
                        {/* <!-- start page title --> */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">Account Management</h4>

                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item">
                                                <a href="javascript: void(0);">Account Management</a>
                                            </li>
                                            <li className="breadcrumb-item active">
                                                Account
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </div>
        </body>
    );
}

export default AccountManagerLayout;
